import * as dayjs from 'dayjs';
import { Component, ReactNode } from 'react';
import CurrencyInput from 'react-currency-input-field';
import DatePicker from 'react-date-picker';
import { NavLink, useNavigate, useParams } from 'react-router';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { toast } from 'react-toastify';
import { IdNameDto } from 'src/shared/api-result.dto';
import { AdminApi } from '../admin-api';
import Header from './Header';
import LoadingButton from './LoadingButton';
import PageLoading from './PageLoading';
import Sidebar from './Sidebar';

import 'react-calendar/dist/Calendar.css';
import 'react-date-picker/dist/DatePicker.css';
import { CustomEventPerson } from './CustomCalendar';

const customParseFormat = require('dayjs/plugin/customParseFormat');
dayjs.extend(customParseFormat);

export default function IncomeEdit(props: any): ReactNode {
  return (
    <IncomeEditComp navigate={useNavigate()} params={useParams()} {...props} />
  );
}

class IncomeEditComp extends Component {
  constructor(
    readonly props: Readonly<{
      children?: ReactNode;
      navigate?: any;
      currentUser?: any;
      params?: any;
    }>,
  ) {
    super(props);
    this.state = {
      isLoading: true,
      isSubmitting: false,
      data: null,
      strValue: '',
      strDate: '',
      categories: [],
      users: [],
    };
  }

  state: Readonly<{
    isLoading: boolean;
    isSubmitting: boolean;
    categories: IdNameDto[];
    strValue: string;
    strDate: string;
    users: CustomEventPerson[];
    data: {
      description: string;
      category: string;
      date: string;
      value: number;
      id: number;
      personId?: number;
    } | null;
  }>;

  async componentDidMount(): Promise<void> {
    const _id = this.props.params.id;

    const _allCat = await AdminApi.get(`/categories`);
    let _allUsers: CustomEventPerson[] = [];

    if (this.props.currentUser.role === 'admin') {
      _allUsers = await AdminApi.get(`/users`);
    }

    this.setState({
      categories: _allCat.map((item: IdNameDto) => ({
        value: item.id,
        label: item.name,
      })),
      users: _allUsers,
    });

    if (_id) {
      const _data = await AdminApi.get(`/incomes/${_id}`);

      this.setState({
        isLoading: false,
        data: _data,
        strValue: _data ? _data.value.toFixed(2).replace('.', ',') : '',
        strDate: _data ? dayjs(_data.date).toISOString() : '',
      });
    } else {
      this.setState({
        isLoading: false,
        data: {
          description: '',
          category: '',
          date: '',
          value: 0,
          personId: null,
        },
      });
    }
  }

  async submit() {
    let _result = null;

    this.setState({ isSubmiting: true });

    if (this.state.data) {
      this.state.data.date = this.state.strDate;
    }

    if (this.state.data?.id) {
      _result = await AdminApi.put(`/incomes/${this.state.data.id}`, {
        description: this.state.data?.description,
        category: this.state.data?.category,
        date: this.state.data?.date,
        value: this.state.data?.value,
        personId: this.state.data?.personId,
      });
    } else {
      _result = await AdminApi.post('/incomes', this.state.data);
    }

    this.setState({ isSubmiting: false });

    if (_result) {
      toast.success('Receita salva com sucesso!');

      setTimeout(() => {
        this.props.navigate('/incomes');
      }, 200);
    }
  }

  canSubmit() {
    return (
      this.state.data?.description?.length &&
      this.state.strDate &&
      this.state.strValue
    );
  }

  render(): ReactNode {
    return this.state.isLoading ? (
      <PageLoading />
    ) : (
      <div>
        <Header
          navigate={this.props.navigate}
          currentUser={this.props.currentUser}
        ></Header>
        <div className="container-fluid">
          <div className="row">
            <Sidebar
              navigate={this.props.navigate}
              currentUser={this.props.currentUser}
            ></Sidebar>
            <main className="ms-sm-auto large-calendar px-md-4">
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 className="h2">
                  {this.state.data?.id
                    ? `Editar ${this.state.data?.description}`
                    : 'Adicionar receita'}
                </h1>
              </div>
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/incomes">Lista de receitas</NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Edição de receita
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="card">
                <div className="card-body">
                  <form>
                    {this.props.currentUser.role === 'admin' && (
                      <div className="mb-3">
                        <label className="form-label">Pessoa</label>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          isClearable={true}
                          name="personId"
                          placeholder="Receita do Plurie"
                          options={this.state.users.map((user) => ({
                            value: user.id,
                            label: user.name,
                          }))}
                          value={
                            this.state.data?.personId
                              ? {
                                  value: this.state.data.personId,
                                  label: this.state.users.find(
                                    (u) => u.id === this.state.data?.personId,
                                  )?.name,
                                }
                              : null
                          }
                          onChange={(e: any) =>
                            this.setState({
                              data: {
                                ...this.state.data,
                                personId: e ? e.value : null,
                              },
                            })
                          }
                        />
                      </div>
                    )}

                    <div className="mb-3">
                      <label className="form-label">Categoria</label>
                      <CreatableSelect
                        options={this.state.categories}
                        value={
                          this.state.data?.category
                            ? this.state.data.category
                                .split(',')
                                .map((item: string) => ({
                                  value: item,
                                  label: item,
                                }))
                            : []
                        }
                        isClearable
                        isMulti
                        onChange={(e: any) =>
                          this.setState({
                            data: {
                              ...this.state.data,
                              category: e
                                .map((item: any) => item.value)
                                .join(','),
                            },
                          })
                        }
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Descrição</label>
                      <input
                        type="email"
                        className="form-control"
                        onChange={(e) =>
                          this.setState({
                            data: {
                              ...this.state.data,
                              description: e.target.value,
                            },
                          })
                        }
                        value={this.state.data?.description}
                        aria-describedby="descriptionHelp"
                      />
                      <div id="emailHelp" className="form-text">
                        Será identificado no relatório de receitas.
                      </div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Data</label>
                      <DatePicker
                        className="form-control"
                        format="dd/MM/yyyy"
                        clearIcon={null}
                        onChange={(d) => {
                          this.setState({
                            strDate: ((d ?? new Date()) as Date).toISOString(),
                          });
                        }}
                        value={this.state.strDate}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Valor</label>
                      <CurrencyInput
                        className="form-control"
                        allowNegativeValue={false}
                        value={this.state.strValue}
                        decimalSeparator=","
                        groupSeparator="."
                        decimalsLimit={2}
                        min={1}
                        onValueChange={(value, name, values) =>
                          this.setState({
                            strValue: value || '',
                            data: { ...this.state.data, value: values?.float },
                          })
                        }
                      />
                    </div>

                    <div className="mb-3">
                      <hr />
                    </div>

                    <div className="d-grid gap-2">
                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={this.state.isSubmitting || !this.canSubmit()}
                        onClick={() => this.submit()}
                      >
                        {this.state.isSubmitting ? (
                          <LoadingButton />
                        ) : (
                          `${this.state.data?.id ? 'Atualizar' : 'Adicionar'} receita`
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}
